<template>
  <div class="mb-5">
    <template v-if="$helper.currencyOptions.length > 1">
      <div class="bg-white d-flex align-center justify-space-between">
      <v-tabs
        v-model="tab"
        color="primary"
        slider-color="primary"
        background-color="white">
        <template v-if="$helper.currencyOptions.length > 1">
          <template v-for="currency in $helper.currencyOptions">
            <v-tab :value="currency.value" :href="`#${currency.value}`" @click="onSelectTab(currency.value)" :key="`tab-invoice-${currency.value}`">
            <img :src="`/images/currency/${currency.value}.svg`" :alt="currency.value" class="mr-2 tab-icon-flag">
              {{ currency.tabName }}
            </v-tab>
          </template>
        </template>
      </v-tabs>
      <v-btn style="float:right;" class="blue white--text mx-1" to="settingtask-billing" elevation="0"
        :disabled="!billingSettingType || billingSettingType != 'monthly'">
        {{ $t('task.send_invoice_to_approve')}}
        <v-chip v-if="countSettingTasks" color="error" style="height: 24px;padding:0 8px;margin-left:5px;">{{
          countSettingTasks }}</v-chip>
      </v-btn>
    </div>
    <v-divider></v-divider>
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="currency in $helper.currencyOptions" :key="currency.value" :value="`${currency.value}`"  >
        <MarketSettingInvoiceComponent :isMainLoading="isMainLoading" @onInitBilling="initData" @changeBillingSettingType="changeBillingSettingType" :projectId="projectId" :marketId="marketId" :meterType="meterType" :areaBillingSettingItems="areaBillingSettingItems" :billingSettingType="billingSettingType" :tabType="currency.value"/>
      </v-tab-item>
    </v-tabs-items>     
    </template>
    <template v-else>
      <div>
        <v-btn style="float:right;" class="blue white--text mx-1" to="settingtask-billing" elevation="0"
          :disabled="!billingSettingType || billingSettingType != 'monthly'">
          {{ $t('task.send_invoice_to_approve')}}
          <v-chip v-if="countSettingTasks" color="error" style="height: 24px;padding:0 8px;margin-left:5px;">{{
            countSettingTasks }}</v-chip>
        </v-btn>
      </div>
      <MarketSettingInvoiceComponent :isMainLoading="isMainLoading" @onInitBilling="initData" @changeBillingSettingType="changeBillingSettingType" :projectId="projectId" :marketId="marketId" :meterType="meterType" :areaBillingSettingItems="areaBillingSettingItems" :billingSettingType="billingSettingType" :tabType="tab"/>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MarketSettingInvoiceComponent from "@/components/MarketSettingInvoice.component.vue";
export default {
  components: {
    MarketSettingInvoiceComponent
  },
  props: {
    isMainLoading: Boolean,
    projectId: String,
    marketId: String,
    meterType: String,
    areaBillingSettingItems: Array,
    billingSettingType: String
  },
  computed: {
    ...mapGetters({
      countSettingTasks: "settingTask/countSettingTasks",
    }),
  },
  watch: {

  },
  data() {
    return {
      tab: this.$globalCurrencyCode,
    }
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      this.$emit("onInitBilling");
    },
    changeBillingSettingType(value) {
      this.$emit("changeBillingSettingType", value);
      this.clearFilter()
    },
    clearFilter() {
      this.filterData = {
        areaName: null,
        meterName: null,
        serviceName: null,
        unit: null,
        price: null,
        discount: null,
        total: null
      }
    },
    onSelectTab(tab) {
      this.tab = tab;
      this.$emit('onSelectTab', tab);
      this.$emit("onInitBilling");
    }
  }
};
</script>

<style>
.nameProd {
  font-size: 1rem;
}

.v-data-table::v-deep th {
  color: #000;
  font-size: 1rem !important;
  text-align: center !important;
}

.v-data-table::v-deep td {
  font-size: 1rem !important;
  text-align: center !important;
  padding-right: 2rem !important;
}
</style>